import React, {Component} from 'react';
import styled from 'styled-components';

import WP from 'WP';
import Image from 'partials/Image';
import SmartLink from 'partials/SmartLink';
import DateFormater from 'partials/DateFormater';
import css from 'css';


class Post extends Component {
    render() {
        const {post} = this.props;
        console.log(post);
        const showImageLink = post.acf.allow_image_link === undefined || post.acf.allow_image_link === true;
        const showReadMore = post.acf.allow_read_more === undefined || post.acf.allow_read_more === true;

        const imageRatio = window.matchMedia("(max-width: 768px)").matches ? '16:9' : '5:4';
        return (
            <PostItem>
                <figure>
                    {showImageLink &&
                    <SmartLink to={post.link}>
                        <Image image={post.featured_image_src} hoverZoom background ratio={imageRatio} showLink/>
                    </SmartLink>
                    }
                    {!showImageLink &&
                        <Image image={post.featured_image_src} hoverZoom background ratio={imageRatio} showLink/>
                    }
                </figure>
                <article>
                    <h3 dangerouslySetInnerHTML={{__html: post.acf.title || post.title.rendered}}/>
                    <span><DateFormater input={post.date}/></span>
                    <p dangerouslySetInnerHTML={{__html: post.acf.excerpt}}/>
                    {showReadMore &&
                    <SmartLink to={post.link}>{WP.trans.readMore || 'Les mer'}</SmartLink>
                    }

                </article>
            </PostItem>
        );
    }
}

export default Post;

const PostItem = styled.section`
    display:flex;
    flex-wrap: wrap;
    padding-bottom: 60px;
    margin-bottom:60px;
    border-bottom:1px solid #8C8C8C;
    justify-content: space-between;
    position:relative;
    max-width:100%;
    &:last-child {
        border-bottom:none;
    }

    @media (max-width: 960px) {
        padding-bottom: 30px;
        margin-bottom:40px;
    }
    @media (max-width: 768px) {
        margin-bottom:0;
        border-bottom:0;
    }

    figure {
        width:39%;
        overflow: hidden;
        a {
            display: block;
            padding-bottom: 0;
            border:none;
        }
        @media (max-width: 768px) {
            width: calc(100% + 50px);
            position:relative;
            margin-bottom:20px;
            margin-left:-25px;
            margin-right:-25px;
        }
        @media (max-width: 480px) {
            a div {
                padding:0;
                height:190px;
            }
        }
    }
    article {
        width: ${css.sizes.rightColumn};
        @media (max-width: 768px) {
            width:100%;
        }
        h3 {
            font-size:43px;
            line-height: 50px;
            margin-bottom:50px;
            font-family: ${css.fonts.bg_bold};
            overflow: hidden;
            text-overflow: ellipsis;
            @media (max-width: 960px) {
                font-size:40px;
                margin-bottom:30px;
                line-height:1.2;
            }
            @media (max-width: 768px) {
                font-size:20px;
                margin-bottom:10px;
            }
            @media (max-width:480px) {
                font-size: 26px;
                line-height: 31px;
            }
        }
        span {
            font-size:14px;
            color:#797979;
            margin-bottom: 10px;
            display:block;
        }
        p {
            font-size:18px;
            margin-bottom:50px;
            line-height:1.5;
            @media (max-width: 960px) {
                margin-bottom: 30px;
            }
            @media (max-width: 768px) {
                margin-bottom: 10px;
                font-size:16px;
            }
        }
        a {
            font-size:18px;
            @media (max-width: 768px) {
                font-size:16px;
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Post.js